import environment from './base';

/*
 * base.ts is the default environment for production.
 * You shouldn't have override anything.
 */

// const baseApi = 'http://103.121.26.154:91/KUWAITINDIA/mobileclientservice/api/admin';
// const baseApi = 'http://91.140.237.8/mobileclientservice/api/admin';

const baseApi = 'https://online.kiecokw.com/mobileclient/api/admin';

const env = environment(baseApi);

const productionEnv = {
  ...env,
  // override anything that gets added from base.
};

export default productionEnv;
